// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__XnFzr","disabled":"Card_disabled__X_Ux5","overlay":"Card_overlay__LLnLd","title":"Card_title__YFhKp","border":"Card_border__WqUtR"};